import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  selectItem,
  setReports,
  setReportType,
  setUsedReport,
  setFilterProps,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  updateReportRequest,
  createReportRequest,
  setTableTitleFilter,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  getAvailableReportsRequest,
  changeDefaultReportRequest,
} = getReportActions();

const toggleDetails = createAction('toggleDetails');
const deleteItemsRequest = createAction('deleteItemsRequest');
const deleteItemsSuccess = createAction('deleteItemsSuccess');
const setFleetProfileSettings = createAction('setFleetProfileSettings');
const visitInspectionsOnFleetPage = createAction('visitInspectionsOnFleetPage');

export {
  // report
  selectItem,
  setReports,
  setUsedReport,
  setReportType,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  updateReportRequest,
  setTableTitleFilter,
  createReportRequest,
  setIgnorePromptStatus,
  resetListAndPagination,
  setInitialStateOmitReport,
  getAvailableReportsRequest,
  changeDefaultReportRequest,
  // report
  toggleDetails,
  deleteItemsRequest,
  deleteItemsSuccess,
  exportReportDataRequest,
  setFleetProfileSettings,
  visitInspectionsOnFleetPage,
};
